export default __webpack_public_path__ + "static/media/beth.cc5547f9.svg";